// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"152":"notification-detail","602":"notification","966":"login"}[chunkId] || chunkId) + "." + {"152":"6431dff0","362":"9cdf86cb","602":"acd15d6d","966":"cb83443c"}[chunkId] + ".css";
};